document.addEventListener('DOMContentLoaded', () => {
	initSectionContainers();
});

/**
 * Initialize each section
 */
function initSectionContainers() {
	const containers = document.querySelectorAll(
		'.wp-block-cancan-section-with-parallax'
	);

	containers.forEach((container) => {
		initParallax(container);
		initMobileSlider(container);
	});
}

/**
 * Initialize GSAP parallax for images inside a single container
 * @param {HTMLElement} container
 */
function initParallax(container) {
	const layers = container.querySelectorAll('.image-container img');
	const SPEED = 3;

	if (!layers.length) return;

	container.addEventListener('mousemove', (e) => {
		const { width, height, left, top } = container.getBoundingClientRect();
		const x = e.clientX - left - width / 2;
		const y = e.clientY - top - height / 2;

		layers.forEach((layer) => {
			gsap.to(layer, {
				x: (x * SPEED) / 100,
				y: (y * SPEED * 2) / 100,
				duration: 0.5,
				ease: 'power3.out',
			});
		});
	});
}

/**
 * Initialize Swiper for the mobile slider inside a single container
 * only if window width <= 767px and the slider is in the viewport
 * @param {HTMLElement} container
 */
function initMobileSlider(container) {
	const BREAKPOINT = 1024;
	const slider = container.querySelector('.mobile-slider');
	if (!slider) return;

	// Track Swiper instance
	let swiperInstance = null;

	// Debounce utility
	const debounce = (fn, delay) => {
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => fn.apply(this, args), delay);
		};
	};

	// Initialize Swiper
	const initialize = () => {
		if (swiperInstance) return;
		swiperInstance = new Swiper(slider, {
			spaceBetween: 16,
			speed: 5000,
			loop: true,
			slidesPerView: 'auto',
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
			freeMode: true,
			freeModeMomentum: false,
			centeredSlides: true,
		});
	};

	// Destroy Swiper
	const destroy = () => {
		if (swiperInstance) {
			swiperInstance.destroy(true, true);
			swiperInstance = null;
		}
	};

	// IntersectionObserver for lazy init
	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && window.innerWidth <= BREAKPOINT) {
					initialize();
					obs.unobserve(slider);
				}
			});
		},
		{ threshold: 0.1 }
	);
	observer.observe(slider);

	// Handle resize inside this container
	const onResize = debounce(() => {
		if (window.innerWidth > BREAKPOINT) {
			destroy();
		} else {
			if (
				!swiperInstance &&
				slider.getBoundingClientRect().top < window.innerHeight
			) {
				initialize();
			}
		}
	}, 200);

	window.addEventListener('resize', onResize);
}
